import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chart-content" }
const _hoisted_2 = { class: "doughnut-chart-container" }
const _hoisted_3 = ["id"]

import { Data } from '../../models';
import DoughnutChartBaseWrapper from './DoughnutChartBaseWrapper.vue';
import { computed, PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DoughnutChart',
  props: {
  reportId: {
    type: String,
    required: true,
  },
  data: {
    type: Object as PropType<Data>,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const legendElementId = computed(() => 'legendContainer-' + props.reportId);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DoughnutChartBaseWrapper, {
        class: "chart",
        "legend-element-id": legendElementId.value,
        title: __props.title,
        data: __props.data
      }, null, 8, ["legend-element-id", "title", "data"])
    ]),
    _createElementVNode("div", {
      id: legendElementId.value,
      class: "legend-container"
    }, null, 8, _hoisted_3)
  ]))
}
}

})